module.exports = __webpack_public_path__ + "img/progress_090.d00f634f.png";